module.exports = {

    // BE VERY CAREFUL with this constants ....

    TASKS_MANAGEMENT: {
        id              : "tasks-management",
        name            : "Basic Tasks management",
        svg             : "whats-done",
        description     : 'Simple yet powerful all-purpose tasks management',
        hint            : "Project views: Task List \\n Project types: Task List, Kanban \\n Custom views: All tasks (board), Tasks by user"
    },
    GANTT: {
        id              : "gantt",
        name            : "Gantt & Waterfall project management",
        svg             : "gantt",
        description     : 'Plan and track your projects with GoodDay Gantt view',
        hint            : "Project views: Gantt\\nCustom views: Gantt all projects"
    },
    AGILE: {
        id              : "agile",
        name            : "Scrum & Agile",
        svg             : "scrum",
        description     : 'Support for all types of Agile project management methodologies',
        hint            : "Project types: Kanban, Sprint, Backlog, Scrum"
    },
    WORKLOAD: {
        id              : "workload",
        name            : "Workload & Resource planning",
        svg             : "workload",
        description     : 'Resource allocation and workload views',
        hint            : "Project views: Workload\\nCustom views: Resource planning\\n Home views: My workload"
    },
    PORTFOLIO: {
        id              : "portfolio",
        name            : "Project Portfolio management",
        svg             : "portfolio",
        description     : 'High-level projects overview & management',
        hint            : "Custom views: Portfolio"
    },
    MEETINGS: {
        id              : "meetings",
        name            : "Meetings",
        svg             : "calendar",
        description     : 'Organize and track meeting notes and action items',
        hint            : "Home screen: My Meetings"
    },
    DOCS: {
        id              : "docs",
        name            : "Docs & Wiki",
        svg             : "notes-docs",
        description     : 'Organize and share all your projects related documents and notes',
        hint            : "Project views: Docs"
    },
    FILES: {
        id              : "files",
        name            : "Files",
        svg             : "files",
        description     : 'Organize and share all your projects related files',
        hint            : "Project views: Files"
    },
    DISCUSSIONS: {
        id              : "discussions",
        name            : "Project discussions",
        svg             : "discussion-2",
        description     : 'Keep all project conversations organized and aligned with other project items',
        hint            : "Project views: Discussion"
    },
    CHATS: {
        id              : "chats",
        name            : "Chats",
        svg             : "chats",
        description     : 'Feature-rich, integrated one-to-one and group chat module',
        hint            : "Create organization announcements chat room"
    },
    TIME_TRACKING: {
        id              : "time-tracking",
        name            : "Time Tracking",
        svg             : "time",
        description     : 'Integrated time tracking, My Time and analytics',
        hint            : "Home views: My Time\\Default required time tracking settings & reports"
    },
    HR: {
        id              : "hr",
        name            : "HR",
        svg             : "hr2",
        description     : 'HR module includes vacations and time-off management, personal goals, overtime and more',
        hint            : "Custom views: Vacations calendar\\nHR reports"
    },
    CLIENTS: {
        id              : "clients",
        name            : "Clients & Customer Portal",
        svg             : "clients-customers",
        description     : 'Manage clients, associate projects with clients and give customers access to their project within GoodDay',
        hint            : 'Project types: Client project',
    },
    FINANCE: {
        id              : "finance",
        name            : "Billing & Finance",
        svg             : "finance",
        description     : 'Track your budgets and expenses',
        hint            : "Enable billing & finance module\\n Custom fields: budget, spent"
    },

};